import { FC, useEffect } from 'react'
//components
import { Button } from '../../Button'
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import { isInViewFooterState, stepState } from '../../../states/messageState'
import { useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import { windowScrollToBottom } from '../../../util/windowScrollToBottom'

export const Start: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent } = useSendMessage()
  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setCurrentStep = useSetRecoilState(stepState)

  useEffect(() => {
    setIsInViewFooter(true)
    windowScrollToBottom()
  }, [])

  /**申請スタート */
  const handleSubmitStart = async () => {
    await handleAddSenderParent('user', '保証申請を行いたい')
    setIsInViewFooter(false)
    await handleAddSenderParent(
      'bot',
      `お届けした商品の不具合によりご不便をお掛けしております。これより保証申請をスタートします。\n\n保証番号かメールアドレスを入力して下さい。`
    )
    handleInViewFooter()
    setCurrentStep('inputInquiryCodeOrEmail')
  }

  return (
    <FooterContent isWide={false}>
      <Button buttonType="outlined" onClick={handleSubmitStart}>
        申請スタート
      </Button>
    </FooterContent>
  )
}
